import React, { useEffect, useState } from "react";
import Select from "react-select";
import { ExamPopUp } from "../IndexPage/ExaminationPreparation/ExamPopUp";
import { useDispatch, useSelector } from "react-redux";
import { LicentiateCertificateSubMenuAPI } from "../../helper/Redux/Slices/DDLSlice/DDLSlice";

export const LicentiateCertificateSubMenuDDL = (props) => {
    const { LicentiateCertificateSubMenuID, setLicentiateCertificateSubMenuID, M_MainSubjectID, M_UserID, Flag, rowData } = props


    const dispatch = useDispatch()

    useEffect(() => {
        const data = { M_MainSubjectID, M_UserID, Flag }
        dispatch(LicentiateCertificateSubMenuAPI({ data }))
    }, [M_MainSubjectID, Flag])

    const { DDLData } = useSelector(state => state.LicentiateCertificateSubMenuData)

    useEffect(() => {
        GetDDLData()
    }, [DDLData])

    const GetDDLData = () => {
        // console.log(DeptDDLDataa)
        if (DDLData && DDLData.table && DDLData.table.length > 0) {
            let list = DDLData.table.map((item, index) => ({
                value: item.m_SubSubjectID,
                label: item.subSubject_Name,
            }))

            setLicentiateCertificateSubMenuID({
                DDL: list,
                ID: Flag === 'Update' ? rowData.m_SubSubjectID : 0,
                Label: Flag === 'Update' ? rowData.subSubject_Name : "Select...",
            })
        }
        else {
            setLicentiateCertificateSubMenuID({
                DDL: [],
                ID: 0,
                Label: "Select...",
            })
        }

    }


    return (
        <>
            <div className="form-group">
                {/* <label className="d-block" htmlFor="NameofLicentiateCertificateSubMenuID"><b>LicentiateCertificateSubMenuID </b></label> */}
                <Select
                    isClearable
                    // isRtl={isRtl}
                    // className="ddl_width"
                    isSearchable
                    maxMenuHeight={150}
                    value={{ value: LicentiateCertificateSubMenuID.ID, label: LicentiateCertificateSubMenuID.Label }}
                    onChange={(e) => {
                        e ?
                            setLicentiateCertificateSubMenuID({ ...LicentiateCertificateSubMenuID, ID: e.value, Label: e.label })
                            :
                            setLicentiateCertificateSubMenuID({ ...LicentiateCertificateSubMenuID, ID: 0, Label: "Select..." })

                    }}
                    options={LicentiateCertificateSubMenuID.DDL}
                />
            </div>
        </>
    )
}